<template>
	<div class="wp-block-column post-tease">
		<figure v-if="imageSrc != ''" class="post-tease-image wp-block-image size-full is-style-drop-shadow">
			<img
				loading="lazy"
				width="380"
				height="260"
				:src="imageSrc"
				:alt="imageAlt"
				class="wp-image"
			/>
		</figure>
		<p
			v-if="category"
			class="post-tease-category has-forest-color has-text-color"
		>
			<a :href="category.link">
				<strong v-html="category.name"></strong>
			</a>
		</p>
		<h3 class="post-tease-title has-heading-secondary-font-size">
			<a :href="post.link" v-html="post.title.rendered"></a>
		</h3>
		<div class="post-tease-excerpt" v-html="post.excerpt.rendered"></div>
		<div class="post-tease-links wp-block-buttons">
			<div class="wp-block-button is-style-link">
				<a :href="post.link" class="wp-block-button__link">Read On</a>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['post'],
        data() {
            return {
                category: null,
                excerpt: null,
                imageAlt: 'Placeholder Image',
                imageSrc: '',
                placeholderImages: [
                    '/wp-content/themes/usdigital-child/assets/dist/images/blog-placeholder-thumbnail-1.png',
                    '/wp-content/themes/usdigital-child/assets/dist/images/blog-placeholder-thumbnail-2.png',
                    '/wp-content/themes/usdigital-child/assets/dist/images/blog-placeholder-thumbnail-3.png',
                ],
            };
        },
        created() {
            // Imagery
            this.imageSrc = this.placeholderImages[this.post.id % 3];
            if (this.post._embedded['wp:featuredmedia']) {
                const { title, caption, alt_text, source_url } = this.post._embedded['wp:featuredmedia'][0];
                this.imageSrc = source_url;
                this.imageAlt= alt_text || caption.rendered || title.rendered;
            }
            // Category
            if (this.post._embedded['wp:term']) {
                this.category = this.post._embedded['wp:term'][0];
            }
        }
	};
</script>

<style></style>
